import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { fetchJSON } from "@purple-dot/libraries/src/fetch";
import { appendResourceType } from "@purple-dot/libraries/src/url";
import { routeTo } from "./components/common/linking";
function expressPage(pageComponent) {
    if (componentHasProps(pageComponent)) {
        pageComponent.getInitialProps = getInitialProps;
    }
    return pageComponent;
}
function componentHasProps(pageComponent) {
    return pageComponent.length > 0;
}
function getInitialProps(_) {
    return _getInitialProps.apply(this, arguments);
}
function _getInitialProps() {
    _getInitialProps = _async_to_generator(function(param) {
        var req, query, asPath, url, data, __redirect, pathname, q, path;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    req = param.req, query = param.query, asPath = param.asPath;
                    if (!!isOnServer(req)) return [
                        3,
                        2
                    ];
                    url = appendResourceType("json", asPath);
                    return [
                        4,
                        fetchJSON(url)
                    ];
                case 1:
                    data = _state.sent();
                    if (data._redirect) {
                        __redirect = data._redirect, pathname = __redirect.pathname, q = __redirect.query, path = __redirect.path;
                        void routeTo({
                            pathname: pathname,
                            query: q
                        }, path);
                        return [
                            2,
                            {}
                        ];
                    }
                    return [
                        2,
                        data
                    ];
                case 2:
                    return [
                        2,
                        query
                    ];
            }
        });
    });
    return _getInitialProps.apply(this, arguments);
}
function isOnServer(req) {
    return !!req;
}
export default expressPage;
